import { Pipe, PipeTransform } from '@angular/core';
import { Specialty } from 'src/app/models/specialty.model';
import { LocaleService } from 'src/app/services/locale.service';


@Pipe({
  name: 'localizedName',
  standalone: false
})
export class LocalizedNamePipe implements PipeTransform {
  constructor(private localeService: LocaleService) { }

  transform(value: Specialty): string | undefined {
    return this.localeService.getSpecialtyName(value);
  }
}
